import { observer } from "mobx-react-lite"

import { TokenStore } from "@/domains/tokens"

/**
 * Wrapped in `observer` so the row reacts to `TokenStore` metadata arriving
 * after the first paint — for a brand-new pool, `symbol` / `decimals` flow
 * in after the repository resolves ERC-20 calls. Without the observer the
 * parent column would render once with "UNKNOWN" / "0" and never catch up,
 * matching the "only one row shows real data" symptom the beta build was
 * hitting.
 */
export const DisplayTokenTableValues = observer(function DisplayTokenTableValues({
  tokens,
  values,
}: {
  tokens: Array<TokenStore>
  values: Array<bigint>
}) {
  return (
    <div className="space-y-0.5 text-secondary-300">
      {tokens.map((token, index) => {
        return (
          <div className="text-right" key={token.address.toString()}>
            <span className="text-t100">{token.displayUnits(values[index] ?? 0n, 2)}</span>
            <span className="ml-1 text-t300">{token.symbol}</span>
          </div>
        )
      })}
    </div>
  )
})
